<template>
  <div class="page-content" v-show="hasgetresult">
    <div class="page-has-recommend" v-if="userinfo.registerCount>0">
      <div class="page-header">
        <router-link class="power-rule" to="/referral/rule">奖励说明</router-link>
        <div class="power-count">{{userinfo.totalPoint}}</div>
        <div class="power-title">
          累计能量石奖励<div class="power"></div>
        </div>
        <div class="line"></div>
        <div class="recommend-title">
          推荐进度如下：
        </div>
        <div class="recommend-process">
          <div class="recommend-step">
            <div class="recommend-step-count">{{userinfo.registerCount}}</div>
            <div class="recommend-step-name">已激活</div>
          </div>
          <div class="point-to"></div>
          <div class="recommend-step">
            <div class="recommend-step-count">{{userinfo.auditionCount}}</div>
            <div class="recommend-step-name">已试听</div>
          </div>
          <div class="point-to"></div>
          <div class="recommend-step">
            <div class="recommend-step-count">{{userinfo.payCount}}</div>
            <div class="recommend-step-name">已付费</div>
          </div>
          <div class="point-to"></div>
          <div class="recommend-step">
            <div class="recommend-step-count">{{userinfo.awardCount}}</div>
            <div class="recommend-step-name">已上完六节课</div>
          </div>
        </div>
      </div>
      <div class="invitees" :key="item.parentId" v-for="item in userinfo.referralUserList">
        <div class="invitees-title">
          <div class="invitees-info">被推荐人：<span>{{item.mobile}}</span></div>
        </div>
        <div class="invitees-process">
          <div class="invitees-step invitees-step-active">
            <div class="invitees-step-title">
              已激活<div class="invitees-right"></div>
            </div>
            <div class="invitees-step-info">
              {{item.registerTimeStr}}
            </div>
          </div>
          <div class="inviees-pointer"></div>
          <div :class="`invitees-step ${item.auditionTime?'invitees-step-active':''}`">
            <div class="invitees-step-title">
              已试听<div class="invitees-right"></div>
            </div>
            <div class="invitees-step-info">
              {{item.auditionTime?item.auditionTimeStr:'否'}}
            </div>
          </div>
          <div class="inviees-pointer"></div>
          <div :class="`invitees-step ${item.progress>=4?'invitees-step-active':''}`">
            <div class="invitees-step-title">
              已付费<div class="invitees-right"></div>
            </div>
            <div class="invitees-step-info">
              {{item.payTime?item.payTimeStr:'否'}}
            </div>
          </div>
          <div class="inviees-pointer"></div>
          <div :class="`invitees-step ${item.progress===5?'invitees-step-active':''}`">
            <div class="invitees-step-title">
              已上完六节课<div class="invitees-right"></div>
            </div>
            <div class="invitees-step-info">
              {{item.learningPoint?`已得${item.learningPoint}能量石`:'无'}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-recommend" :style="configinfo.img?`background-image:url(${configinfo.img})`:''">
      <div class="page-norec-header">
        <router-link class="power-rule" to="/referral/rule">奖励说明</router-link>
        <div class="power-count">{{userinfo.payCount}}</div>
        <div class="power-title">
          累计能量石奖励<div class="power"></div>
        </div>
        <div class="line"></div>
        <div class="power-desc">
          暂时还没有推荐，听说推荐小伙伴试听可以获得大额能量石，开始行动吧～
        </div>
      </div>
      <div class="refer-time">·4月31日前邀请好友报名·</div>
      <div class="bt-recommend" @click="showShare"></div>
      <div class="reward-power-count">10000<span>个</span></div>
      <div class="gift-one">
        <!-- <p>1节</p>
        <p>体验课</p> -->
        <p>名师直播课</p>
        <p>2节</p>
      </div>
      <div class="gift-two">
        <p>能量石</p>
        <p>4000个</p>
      </div>
    </div>
    <div class="poster-container" v-show="isShowPoster">
      <div class="poster-img">
        <img :src="posterUrl">
        <p>长按图片分享给好友</p>
        <button class="rules-model__close" @click="isShowPoster=false">
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import cookie from 'js-cookie'
import moment from 'moment'
import { getStudentList } from '@/api/account'
import { referralDetail, createPoster } from '@/api/referral'
import { getConfigListByGroup } from '@/api/config'
import { Toast } from 'vant'
import { APPID, APPKEY, CHANNELID, REQUESTURL, ACTIVITYCODE, TEMPLATEID } from '@/config/referral.js'
export default {
  data () {
    return {
      userinfo: {
        registerCount: 0
      },
      hasgetresult: false,
      posterUrl: '',
      isShowPoster: false,
      configinfo: {}
    }
  },
  async created () {
    referralDetail({
      familyId: cookie.get('mbfamilyid')
    }).then(res => {
      if (res.code === 200 && res.data && res.data.registerCount > 0) {
        res.data.referralUserList.forEach(item => {
          item.auditionTimeStr = moment(item.auditionTime).format('YYYY/MM/DD')
          item.payTimeStr = moment(item.payTime).format('YYYY/MM/DD')
          item.registerTimeStr = moment(item.registerTime).format('YYYY/MM/DD')
        })
      }
      this.userinfo = res.data
      this.hasgetresult = true
    })
    const configinfo = await getConfigListByGroup({
      group: 'officialAccount'
    })
    if (configinfo.code === 200 && configinfo.data.length > 0) {
      this.configinfo = JSON.parse(configinfo.data[0].value)
    }
  },
  methods: {
    showShare () {
      if (this.posterUrl) {
        this.isShowPoster = true
      } else {
        this.getPosterUrl()
      }
    },
    getPosterUrl () { // 获取海报url
      var parentId = cookie.get('mbparentid')
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      getStudentList({ parentId }).then(res => {
        Toast.clear()
        if (res.data) {
          for (let i in res.data) {
            if (i === '0') {
              this.firststudentinfo = res.data[i]
              this.studentid = this.firststudentinfo.id
              this.studentavatarUrl = this.firststudentinfo.avatarUrl
              this.studentname = this.firststudentinfo.name
              break
            }
          }
        } else {
          console.log('获取信息失败')
          return
        }
        if (this.posterUrl) {
          this.isShowPoster = true
        } else {
          this.createPoster(parentId)
        }
      }).catch(() => {
        Toast.clear()
      })
    },
    createPoster (parentId) { // 创建海报
      const qrCode = `https://${REQUESTURL}#/landingpage/invite?appId=${APPID}&channelId=${CHANNELID}&channelKeyword=${parentId}&activityCode=${ACTIVITYCODE}&studentavatarUrl=${this.studentavatarUrl}&studentname=${this.studentname}`
      createPoster({
        userId: parentId,
        appKey: APPKEY,
        templateId: TEMPLATEID,
        qrCode,
        img: this.studentavatarUrl,
        text: this.studentname

      }).then(res => {
        if (res.data) {
          this.posterUrl = res.data
          this.isShowPoster = true
        } else {
          this.isShowPoster = false
          console.log('生成海报失败')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/img/referral/spriteout/sprites.scss";
.page-content{
  background-color:#F0F0F0;
}
.page-has-recommend{
  background:url(~@/assets/img/referral/course-info-bg.png) no-repeat;
  background-size:contain;
  min-height:100vh;
  padding-top:42px;
}
.page-header{
  width:680px;
  background:white;
  border-radius: 20px;
  height:486px;
  padding:70px 30px 0;
  margin:0 auto;
  position:relative;
}
.power-rule{
  position:absolute;
  top:22px;
  right:25px;
  text-decoration: underline;
  font-size: 22px;
  font-weight: 400;
  color: #666666;
}
.power-count{
  height: 80px;
  font-size: 80px;
  font-family: Arial;
  font-weight: bold;
  line-height: 80px;
  text-align: center;
}
.power-title{
  height: 26px;
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin-top:20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.power{
  @include sprite(power);
  margin-left:14px;
}
.line{
  width:620px;
  margin:42px auto 0;
  height:2px;
  background:#DEDEDE ;
}
.recommend-title{
  height: 26px;
  font-size: 27px;
  font-weight: bold;
  color: #333333;
  line-height: 43px;
  margin-top:36px;
}
.recommend-process{
  margin-top:40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.recommend-step{
  // width: 160px;
  text-align: center;
}
.recommend-step-count{
  height: 36px;
  font-size: 48px;
  font-weight: bold;
  color: #333333;
  line-height: 53px;
}
.recommend-step-name{
  height: 24px;
  font-size: 26px;
  font-weight: 400;
  color: #999999;
  line-height: 53px;
  margin-top:20px;
}
.point-to{
  @include sprite(pointer);
}
.invitees{
  width:680px;
  background:white;
  border-radius: 20px;
  padding:30px;
  margin:30px auto 0;
}
.invitees-title{
  font-size: 27px;
  font-weight: bold;
  color: #333333;
  line-height: 43px;
  padding-bottom:20px;
  border-bottom:1px solid #DEDEDE;
  span{
    color:#F85718;
  }
}
.invitees-process{
  margin-top:40px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.invitees-step{

}
.invitees-step-title{
  font-size: 26px;
  font-weight: bold;
  color: #999999;
  line-height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.invitees-right{
  margin-left:10px;
  display:none;
  @include sprite(pass)
}
.invitees-step-info{
  font-size: 22px;
  font-weight: 400;
  color: #999999;
  line-height: 53px;
  text-align: center;
  display:none;
}

.invitees-step-active{
  .invitees-step-title{
    color: #333333;
  }
  .invitees-right{
    display:block;
  }
  .invitees-step-info{
    display:block;
  }
}

.inviees-pointer{
  @include sprite(right)
}

.not-recommend{
  background:url(~@/assets/img/referral/bg-img.png) no-repeat;
  background-size:contain;
  min-height:1578px;
  padding-top:42px;
  position: relative;
}
.page-norec-header{
  width:680px;
  background:white;
  border-radius: 20px;
  padding:70px 30px 0;
  margin:0 auto;
  overflow:hidden;
  position: relative;
}
.power-desc{
  width:544px;
  margin:30px auto;
  font-size: 26px;
  font-weight: 400;
  color: #999999;
  line-height: 48px;
}
.bt-recommend{
  @include sprite(bt);
  line-height: 94px;
  border-radius: 47px;
  color: white;
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  margin:0 auto;
  position:absolute;
  top:1436px;
  left:50%;
  transform: translate(-50%,0);
}
.refer-time{
  position: absolute;
  top:895px;
  width: 100%;
  line-height: 29px;
  font-size: 30px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
}
.reward-power-count{
  position: absolute;
  top:1070px;
  left:235px;
  font-size: 45px;
  font-weight: bold;
  color: #EA7A30;
  span{
    font-size:25px;
  }
}
.gift-one,.gift-two{
  position:absolute;
  top:1235px;
  left:103px;
  width: 240px;
  height: 106px;
  text-align: center;
  p{
    font-size: 30px;
    font-weight: 400;
    color: #EA7A30;
    line-height:40px;
  }
  p:last-child{
    font-weight: bold;
  }
}
.gift-two{
  left:405px;
}
.poster-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.8);
  z-index: 999;
  .poster-img{
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 552px;
    text-align: center;
    img {
      width: 552px;
      border:4px solid #4564DC;
    }
    p {
      font-size: 28px;
      color: #FFFEFE;
      line-height: 28px;
      font-weight:bold;
      text-align: center;
      padding:20px 0px;
    }
  }
  .rules-model__close {
    width: 56px;
    height: 56px;
    display: inline-block;
    background: url(https://img.vipkidstatic.com/prt/image/tools/upload/NkWGvlDVGXLDD.png) no-repeat;
    background-size: cover;
  }
}
</style>
